import { render, staticRenderFns } from "./OpenTradesView.vue?vue&type=template&id=163c6626&"
import script from "./OpenTradesView.vue?vue&type=script&lang=js&"
export * from "./OpenTradesView.vue?vue&type=script&lang=js&"
import style0 from "./OpenTradesView.vue?vue&type=style&index=0&id=163c6626&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports